import type { OwnedParking } from '@repo/domain';

import type { ActivationState, ActivationReadiness } from '@features/ownedParkingManage/types';

export const getActivationReadiness = (parking: OwnedParking): ActivationReadiness => {
  const spotsFulfilled = parking.totalSpots > 0;

  const galleryImagesLength = parking.images.filter(
    (image) =>
      image.type === 'default' && (image.relatedTo.object === 'address' || image.relatedTo.object === 'parking')
  ).length;
  const entranceImagesFulfilled = galleryImagesLength > 0;

  const settlementsFulfilled =
    !!parking.billing?.bankAccount?.id && !!parking.billing?.address?.city && !!parking.billing?.name;

  let state: ActivationState = 'cantRequest';
  if (parking.status === 'draft') {
    if (!spotsFulfilled || !entranceImagesFulfilled || !settlementsFulfilled) {
      state = 'cantRequest';
    } else {
      state = 'notRequested';
    }
  } else {
    state = 'requested';
  }

  return {
    steps: {
      spotsFulfilled,
      entranceImagesFulfilled,
      settlementsFulfilled,
    },
    state,
  };
};
